const baseConfig = {
  development: {
    // baseURL: 'http://192.168.20.212:8013',
    // wsURL: 'ws://192.168.20.212:8013',
    // baseURL: 'http://100.64.72.91:8003',
    // wsURL: "ws://100.64.72.91:8003",
    // wsURL: 'ws://dev.tradoc.ocr.bailian-ai.com:8003'
    // baseURL: "https://api.demo.tradoc.ocr.bailian-ai.com/v2",
    // wsURL: "wss://api.demo.tradoc.ocr.bailian-ai.com/v2",
    baseURL: "https://api-aiocr.cloud-sh.com/v3",
    wsURL: "wss://api-aiocr.cloud-sh.com/v3"
  },
  test: {
    baseURL: "https://api-aiocr.cloud-sh.com/v3",
    wsURL: "wss://api-aiocr.cloud-sh.com/v3"
  },
  ys: {
    baseURL: "http://api-demo.bailian-ai.com/template_config",
  },
  ycv3_demo: {
    baseURL: "https://api.demo.tradoc.ocr.bailian-ai.com/v2",
    wsURL: "wss://api.demo.tradoc.ocr.bailian-ai.com/v2"
  },
  production: {
    baseURL: "https://common.tradoc.ocr.bailian-ai.com/api",
    wsURL: "wss://common.tradoc.ocr.bailian-ai.com/api"
  },
  v2_prod: {
    baseURL: "https://api-aiocr.cloud-sh.com/v3",
    wsURL: "wss://api-aiocr.cloud-sh.com/v3"
  }
};


// http://39.96.194.226:8003/swagger-ui.html#/
//http://100.64.72.159:8003


let url = process.env.VUE_APP_ZURL;
let pre = '',
  end = '';
if (url.includes('https://')) {
  pre = 'wss://'
  end = url.substr(8, url.length - 1);

} else {
  pre = 'ws://';
  end = url.substr(7, url.length - 1);
}
let config = {};
if (process.env.VUE_APP_ZURL.length > 0) {
  // 定义任子行导出接口url
  config = {
    baseURL: process.env.VUE_APP_ZURL,
    wsURL: pre + end
  }
} else {
  config = baseConfig[process.env.VUE_APP_TITLE || 'development'];
}

export default config;